import { computed, Injectable, signal } from '@angular/core';

@Injectable({providedIn: 'root'})
export class McsApiService {
    private patientId = signal<string | null>(null);
    private baseUrl = computed(() => `api/main/member/patients/${this.patientId()}/consents/`);

    private _error = signal<string | null>(null);
    readonly error = this._error.asReadonly();

    // tracks whether consents are available for the current patient
    private _consentsAvailable = signal<boolean>(false);
    readonly consentsAvailable = this._consentsAvailable.asReadonly();

    setError(message: string | null) {
        this._error.set(message);
    }

    setPatientId(id: string) {
        this.patientId.set(id);
    }

    setConsentsAvailable(value: boolean) {
        this._consentsAvailable.set(value);
    }

    constructURL(url: string, params?: Map<string, string | number>): string {
        if (params && params.size > 0) {
            const queryParams: string[] = [];
            params.forEach((v, k) => {
                queryParams.push(`${k}=${encodeURIComponent(String(v))}`);
            });
            url = `${url}?${queryParams.join('&')}`;
        }
        return this.baseUrl() + url;
    }
}
